export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7383.7590a651.jpg";